import React, { Component } from 'react';
import {Loyalty,Announcement,Mail} from '@material-ui/icons'
import SimpleSnackbar from '../components/snackbar'
import {observer} from 'mobx-react'
import {PropTypes as MobxPropTypes} from 'mobx-react';
@observer class Footer extends Component{
    
    handleClick=()=>{
  
        this.context.store.ToggleSnackState();
    }
    render(){
        return(
            <footer className="App-footer">
             <div><Loyalty className='footerIcon' /> Copyright <a>WEN-JY@github.com</a> 2018<a href="#"><Announcement className='footerIcon' />Wechat</a></div>
            <SimpleSnackbar />
            <div ><a href="https://segmentfault.com/u/lanlandejishuzhai">SegmentFault</a><a href="https://github.com/WEN-JY">Github</a>
            <a
            onClick={this.handleClick}
            ><Mail className='footerIcon'/>Gmail</a></div>
           
            </footer>
        )
    }
}
Footer.contextTypes={
    store: MobxPropTypes.observableObject.isRequired
}
export default Footer;



// WEBPACK FOOTER //
// ./src/index/footer.js